import React from 'react';
import { VEHICLE_STATUS } from '../lib/format';

export default function VehicleStatusBadge({ status }) {
  const cfg = VEHICLE_STATUS[status] || { label: status, classes: 'bg-slate-100 text-slate-700 border border-slate-200' };
  return (
    <span
      className={`inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium ${cfg.classes}`}
      data-testid="vehicle-status-badge"
    >
      {cfg.label}
    </span>
  );
}
